import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Button from 'material-ui/Button';
import Hidden from 'material-ui/Hidden';

import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import * as authActions from '../../auth/auth.actions';
import { getCurrentUser, getCurrentUserRole } from '../../user/user.selectors';
import { UserRoles } from '../../user/user.constants';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons/Icons';
import colors from '../../../ui/colors';
import { Menu } from 'material-ui';
import { MenuItem } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui-icons/MoreVert';

const styles = theme => ({
  root: {
    background: '#29694D',
  },
  header: {
    color: theme.palette.common.white,
    'box-sizing': 'border-box',
    padding: '1.25rem 0 1rem 0',
    margin: '0 auto',
    maxWidth: '1040px',
    '@media (max-width:1040px)': {
      padding: '0.5rem 0.5rem 0.5rem 1.25rem',
    },
    '@media (max-width:520px)': {
      padding: '0.5rem 0.5rem 0 1.25rem',
    },
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  headerLink: {
    flex: '1',
    padding: '8px 16px 0 0',
  },
  link: {
    padding: '8px 8px 8px 2px',
  },
  mobileMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileLogo: {
    flex: 1,
  },
  menuToggle: {
    color: '#fff',
  },
});

class AppHeader extends Component {
  state = {
    anchorEl: null,
  };

  handleLogoutClick = event => {
    const { logoutUser } = this.props;
    logoutUser();
    this.closeMenu();
  };

  linkTo = link => {
    const { history } = this.props;
    history.push(link);
    this.closeMenu();
  };

  openMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { online, role, classes, showMenu } = this.props;
    if (classes.header.indexOf('pdfHide') < 0) {
      classes.header = classes.header + ' pdfHide';
    }
    const shouldRenderMainMenuBtns = showMenu;
    const shouldRenderUserListBtn = role === UserRoles.SUPERUSER;
    const open = Boolean(this.state.anchorEl);

    return (
      <div className={classes.root}>
        <header className={classes.header}>
          <Hidden xsDown>
            <div className={classes.flexRow}>
              <div className={classes.headerLink}>
                <NavLink to="/" className={classes.link}>
                  <Icon icon={ICONS.LOGO} fill={colors.WHITE} width={'179px'} height={'12px'} />
                </NavLink>
              </div>
              {shouldRenderMainMenuBtns && (
                <NavLink to="/profile">
                  <Button color="contrast">Omat tietoni</Button>
                </NavLink>
              )}
              {shouldRenderMainMenuBtns &&
                shouldRenderUserListBtn && (
                  <NavLink to="/users">
                    <Button color="contrast">Käyttäjähallinta</Button>
                  </NavLink>
                )}
              <Button type="button" color="contrast" onClick={this.handleLogoutClick}>
                Kirjaudu ulos
              </Button>
            </div>
          </Hidden>

          <Hidden smUp>
            <div className={classes.mobileMenu}>
              <NavLink to="/" className={classes.mobileLogo}>
                <Icon icon={ICONS.LOGO} fill={colors.WHITE} width={'179px'} height={'12px'} />
              </NavLink>

              <IconButton
                className={classes.menuToggle}
                aria-label="More"
                aria-owns={open ? 'long-menu' : null}
                aria-haspopup="true"
                onClick={this.openMenu}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu id="simple-menu" anchorEl={this.state.anchorEl} open={open} onRequestClose={this.closeMenu}>
                {shouldRenderMainMenuBtns && <MenuItem onClick={e => this.linkTo('/profile')}>Omat tietoni</MenuItem>}
                <MenuItem disabled={!online} onClick={this.handleLogoutClick}>
                  Kirjaudu ulos
                </MenuItem>
              </Menu>
            </div>
          </Hidden>
        </header>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const role = getCurrentUserRole(state);
  const online = state.offline.online;
  return {
    currentUser,
    online,
    role,
  };
};

const ConnectedAppHeader = connect(mapStateToProps, Object.assign({}, authActions))(AppHeader);

export default withStyles(styles)(ConnectedAppHeader);



// WEBPACK FOOTER //
// ./src/modules/core/components/AppHeader.js